/**
 * 自动上报配置 - 接口定义
 *
 * 失败处理由 request.ts 的响应拦截器统一覆盖，业务代码无需判 code。
 * 分页参数用 page_size。
 */
import { apiGet, apiPost, apiPut, apiDelete } from '@/utils/request';
import { parsePaginatedResponse } from '@/utils/apiResponse';
import { DEFAULT_PAGE_SIZE } from '@/constants/api';
import type { AutoReportEnums, AutoReportItem, AutoReportPayload } from '@/types/autoReporting';

const BASE = '/lead-validity-auto-reports';

export const autoReportingApi = {
  /**
   * 表单枚举。有效性 code 按渠道取值，同一 code 在不同渠道含义不同，
   * 因此必须选完渠道再带 source 拉一次。
   */
  enums: (source?: string) => apiGet<AutoReportEnums>(`${BASE}/enums`, source ? { source } : {}),

  list: (params: Record<string, unknown> = {}) =>
    apiGet(BASE, { page: 1, page_size: DEFAULT_PAGE_SIZE, ...params }).then((d) =>
      parsePaginatedResponse<AutoReportItem>(d),
    ),

  show: (id: number) => apiGet<AutoReportItem>(`${BASE}/${id}`),

  create: (data: AutoReportPayload) => apiPost(BASE, data),

  /** 部分更新：只校验并覆盖本次提交的字段，列表页可只提交 { status } 切开关 */
  update: (id: number, data: AutoReportPayload) => apiPut(`${BASE}/${id}`, data),

  remove: (id: number) => apiDelete(`${BASE}/${id}`),
};
